import React from "react";
import { Control, FieldValues, Path } from "react-hook-form";
import styled from "@emotion/styled";

import { Flex } from "../../../../styles/utility-components";
import AllCountriesInput from "./all_countries_input/AllCountriesInput";
import CoreCountriesInput from "./core_countries_input/CoreCountriesInput";

type CountryInputProps<T extends FieldValues> = {
  countryFieldName: Path<T>;
  languageFieldName: Path<T>;
  control: Control<T, unknown>;
  internationalDataAccess: boolean;
};

export default function CountryInput<T extends FieldValues>({
  countryFieldName,
  languageFieldName,
  control,
  internationalDataAccess,
}: CountryInputProps<T>) {
  if (internationalDataAccess === false) {
    return <CoreCountriesInput name={countryFieldName} control={control} />;
  }

  return (
    <Container>
      <AllCountriesInput
        countryFieldName={countryFieldName}
        languageFieldName={languageFieldName}
        control={control}
      />
    </Container>
  );
}

const Container = styled(Flex)({
  flexDirection: "column",
  gap: 4,
  marginTop: 24,
});
